import { gql } from "@apollo/client";

export const GET_CONVERSATIONS = gql`
  query Conversations($where: ConversationWhereInput!, $skip: Int, $limit: Int) {
    conversations(where: $where, skip: $skip, limit: $limit) {
      id
      psid
      name
      pageId
      direction
      message
      attachments {
        type
        url
      }
      status
      billDelivery {
        status
        orderGroup
      }
      repliedBy {
        id
        nickname
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_CONVERSATION_THREADS = gql`
  query ConversationThreads($pageId: String!, $skip: Int, $limit: Int) {
    conversationThreads(pageId: $pageId, skip: $skip, limit: $limit) {
      psid
      pageId
      name
      profilePic
      lastMessage
      lastDirection
      lastCreatedAt
      unreadCount
    }
  }
`;

export const GET_CONVERSATION_UNREAD_COUNT = gql`
  query ConversationUnreadCount($pageIds: [String!]!) {
    conversationUnreadCount(pageIds: $pageIds)
  }
`;
